export default __webpack_public_path__ + "static/media/rabbet.1a10e753.png";